import React from "react";

export default function CustomRoutingMap() {
  return (
    <div style={{ padding: 16 }}>
      <h2>Custom Routing Map</h2>
      <p>Funkcionalita custom routing будет implementována позже</p>
    </div>
  );
}
